import { IQueryConditionHandler } from './iquerycondition.handler';
import { QueryCondition, SingleDateTimeValue } from '@farris/component-querycondition';
import { CompareType } from '../enum/compare-type.enum';
import { ValueType } from '../enum/value-type.enum';
import { RelationType } from '../enum/relation-type.enum';

export class SingleDateTimeHandler implements IQueryConditionHandler {
  convert(qc: QueryCondition) {
    const dtv = (qc.value as SingleDateTimeValue);
    return [{
      'FilterField': qc.fieldCode,
      'Compare': (qc.compareType || qc.compareType === 0) ? qc.compareType : CompareType.Equal,
      'Value': dtv.datetimeValue,
      'Relation': (qc.relation || qc.relation === 0) ? qc.relation : RelationType.And, // and undefined
      'Expresstype': ValueType.Value,
      'Lbracket': qc.Lbracket || null,
      'Rbracket': qc.Rbracket || null
    }];
  }
}
